<template>
  <v-fade-transition>
    <v-container fluid class="fill-height ma-0 pa-0" v-show="!transition">
      <v-row class="fill-height ma-0 pa-0">
        <v-col class="fill-height ma-0 pa-0">
          <v-card class="fill-height rounded-10">
            <v-card-text style="width: 100%; height: 90%">
              <div ref="associationView"></div>
            </v-card-text>
            <v-card-text v-if="!libraryAssociationResponse" class="py-1">
              <v-row no-gutters class="mb-3">
                <v-col
                  v-for="(_, index) in selectedGaugeLibraries"
                  :key="index"
                  align="center"
                  class="my-1"
                >
                  <v-btn
                    icon
                    elevation="0"
                    @click="setSelectedGaugeIndex(index)"
                  >
                    <v-avatar
                      size="32"
                      :color="
                        index === selectedGaugeIndex
                          ? 'primary'
                          : selectedGaugeLibraries[index]
                          ? 'success'
                          : ''
                      "
                    >
                      <span
                        v-if="
                          index === selectedGaugeIndex ||
                          selectedGaugeLibraries[index]
                        "
                        class="white--text"
                      >
                        {{ index + 1 }}
                      </span>
                      <span
                        v-if="
                          index !== selectedGaugeIndex &&
                          !selectedGaugeLibraries[index]
                        "
                      >
                        {{ index + 1 }}
                      </span>
                    </v-avatar>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-fade-transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import * as NCFrontend from "@osteon-nexus-connect-lib/nc-frontend"

export default {
  name: "AssociationDiv",

  associationView: null,

  computed: {
    ...mapGetters([
      "validateScansResponse",
      "sessionType",
      "transition",
      "libraryAssociationEnabled",
      "selectedGaugeIndex",
      "selectedGaugeLibraries",
      "libraryAssociationResponse",
      "libraryAssociationViewOptions"
    ]),

    enableAssociation() {
      return this.libraryAssociationEnabled
    },

    gaugeIndex() {
      return this.selectedGaugeIndex
    }
  },

  watch: {
    enableAssociation(val) {
      if (this.associationView && this.associationView.visualisation) {
        if (val) {
          this.associationView.visualisation.enableLibraryAssociation(true)
        } else {
          this.associationView.visualisation.enableLibraryAssociation(false)
        }
      }
    },

    gaugeIndex(val) {
      if (val >= 0 && this.associationView) {
        this.associationView.visualisation.zoomToGauge(val)
      }
    },

    libraryAssociationViewOptions: {
      handler(val) {
        if (this.associationView && this.associationView.visualisation) {
          this.associationView.visualisation.setScanGaugesVisible(
            val.showScanGauges
          )
          this.associationView.visualisation.setScanTissueVisible(
            val.showScanTissue
          )
          this.associationView.visualisation.setGaugeLibrariesVisible(
            val.showLibraries
          )
          this.associationView.visualisation.setNarrowScanBodiesVisible(
            val.showLibraries
          )
          this.associationView.visualisation.setConstructedGaugeLibrariesVisible(
            val.showConstructedLibraries
          )
          this.associationView.visualisation.setConstructedNarrowScanBodyLibrariesVisible(
            val.showConstructedLibraries
          )
        }
      },
      deep: true
    },

    libraryAssociationResponse(val) {
      if (val) this.associatedView()
    }
  },

  methods: {
    ...mapActions([
      "setSelectedGaugeIndex",
      "setLibraryAssociationEnabled",
      "setLibraryAssociationViewOptions"
    ]),

    associatedView() {
      this.associationView.visualisation.setLibraryAssociationData(
        this.libraryAssociationResponse
      )
      this.associationView.visualisation.setGaugeLibrariesVisible(false)
      this.associationView.visualisation.setNarrowScanBodiesVisible(false)
    }
  },

  mounted() {
    this.associationView = NCFrontend.createView(
      "libraryAssociationView",
      this.$refs.associationView
    )
    NCFrontend.add(this.associationView)

    this.associationView.setVisualisation(
      new NCFrontend.Visualisations.LibraryAssociation(
        this.associationView.element,
        {
          fixedScan: this.validateScansResponse.fixedScan,
          scanAnalysis: this.validateScansResponse.scanAnalysis,
          immediateCase: this.sessionType === "immediate"
        }
      )
    )

    if (this.libraryAssociationResponse) {
      setTimeout(() => {
        this.setLibraryAssociationEnabled(false)
        this.setLibraryAssociationViewOptions({
          showScanGauges: false,
          showScanTissue: true,
          showLibraries: false,
          showConstructedLibraries: true
        })
        this.associatedView()
      }, 0)
    }
  }
}
</script>
